import { render, staticRenderFns } from "./EmailsConnector.vue?vue&type=template&id=5d2ff3fc&scoped=true&"
import script from "./EmailsConnector.vue?vue&type=script&lang=js&"
export * from "./EmailsConnector.vue?vue&type=script&lang=js&"
import style0 from "./EmailsConnector.vue?vue&type=style&index=0&id=5d2ff3fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2ff3fc",
  null
  
)

export default component.exports